import * as React from 'react';
import * as moment from 'moment';
import { Select, Row, Col, InputNumber } from 'antd';


interface IProps {
	value?: string;
	mode: ControlMode;
	onChanged?: (e) => void;
	label?: string;

	showMinutes?: boolean;
	showSeconds?: boolean;
	showHours?: boolean;
	showDays?: boolean;
	showMonths?: boolean;
	showYears?: boolean;
}

interface IState {
	years: number,
	months: number;
	days: number;
	hours: number;
	minutes: number;
	seconds: number;
}

export default class TimeSpam extends React.Component<IProps, IState>{

	constructor(props) {
		super(props);

		this.state = {
			hours: 0,
			minutes: 0,
			seconds: 0,
			years: 0,
			days: 0,
			months: 0
		}
	}

	componentDidMount() {
		if (this.props.value) {
			var struct = JSON.parse(this.props.value)

			this.setState(struct as any);
		}
	}

	updateValue = () => {
		if (this.props.onChanged)
			this.props.onChanged(JSON.stringify(this.state));
	}

	handleChange = (name: string) => {
		return (e) => {
			this.setState({ [name]: e } as any, this.updateValue);
		} 
	}

	render() {

		
		return (
			<div className='time-span'>
				<label>{this.props.label}</label>

				{this.props.showYears && < InputNumber
					className='time-span-value'
					style={{ marginLeft: '5px' }}
					disabled={this.props.mode == 'display'}
					min={0}
					value={this.state.years}
					parser={v => Number.parseInt(v.replace(" years", ''))}
					onChange={this.handleChange('years')}
					formatter={v => `${v} years`} />}

				{this.props.showMonths && < InputNumber
					className='time-span-value'
					style={{ marginLeft: '5px' }}
					disabled={this.props.mode == 'display'}
					min={0}
					value={this.state.months}
					parser={v => Number.parseInt(v.replace(" months", ''))}
					onChange={this.handleChange('hours')}
					formatter={v => `${v} months`} />}

				{this.props.showDays && < InputNumber
					className='time-span-value'
					style={{ marginLeft: '5px' }}
					disabled={this.props.mode == 'display'}
					min={0}
					value={this.state.days}
					parser={v => Number.parseInt(v.replace(" days", ''))}
					onChange={this.handleChange('days')}
					formatter={v => `${v} days`} />}

				{this.props.showHours && < InputNumber
					className='time-span-value'
					style={{marginLeft: '5px'}}
					disabled={this.props.mode == 'display'}
					min={0}
					value={this.state.hours}
					parser={v => Number.parseInt(v.replace(" hours", ''))}
					onChange={this.handleChange('hours')}
					formatter={v => `${v} hours`} />}

				{this.props.showMinutes && <InputNumber
					className='time-span-value'
					min={0}
					style={{ marginLeft: '5px' }}
					disabled={this.props.mode == 'display'}
					value={this.state.minutes}
					parser={v => Number.parseInt(v.replace(" mins", ''))}
					onChange={this.handleChange('minutes')}
					formatter={v => `${v} mins`} />}

				{this.props.showSeconds && <InputNumber
					className='time-span-value'
					min={0}
					style={{ marginLeft: '5px' }}
					disabled={this.props.mode == 'display'}
					value={this.state.seconds}
					parser={v => Number.parseInt(v.replace(" seconds", ''))}
					onChange={this.handleChange('seconds')}
					formatter={v => `${v} seconds`} />
				}
						
				</div>);
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/time-spam.tsx